// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"1474bfe8","814":"f165370a"}[chunkId] + ".chunk.css";
};